export const isNotEmptyArray = (arr: any) =>
  Array.isArray(arr) && arr.length > 0;
